import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a83733e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SettingsContainer" }
const _hoisted_2 = { class: "SettingsName" }
const _hoisted_3 = { class: "SwitchGrid" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Translate('Systems')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.SystemManagment.CurrentSystems, (sys) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: sys }, [
          (sys !== 'Main')
            ? (_openBlock(), _createBlock(_component_CookiesCheckBox, {
                key: 0,
                class: "W-100",
                Name: _ctx.Translate(sys),
                onChanged: ($event: any) => (_ctx.SaveConfig(sys + '_Active', _ctx.MEMRead('Config' + sys))),
                Default: _ctx.$store.state.CookiesConfig[sys + '_Active'],
                Type: 'Switch',
                Res: 'Config' + sys
              }, null, 8, ["Name", "onChanged", "Default", "Res"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _hoisted_4
  ]))
}